import React, { useEffect, useState } from 'react';
import './Home.css';
import Header from '../../Components/Header/Header';
import HomeGames from '../../Components/HomeGames/HomeGames';
import Footer from '../../Components/Footer/Footer';
import AboutSection from '../../Components/AboutSection/AboutSection';
import AdComponent from '../../Components/AdComponent/AdComponent';
import { FaCoins, FaVideo } from 'react-icons/fa';
import { useRef } from 'react';

function Home() {
  const [showPopUp, setshowPopUp] = useState(false)
  const [showOopsPopUp, setShowOopsPopUp] = useState(false);
  const [pendingUrl, setPendingUrl] = useState(null);
  const [coins, setCoins] = useState(() => {
    return parseInt(localStorage.getItem('user_coins')) || 0;
  });
  const [loadingAd, setLoadingAd] = useState(false);
  const [adError, setAdError] = useState('');

  const adTimerRef = useRef(null);

  useEffect(() => {
    localStorage.setItem('user_coins', coins);
  }, [coins]);

  useEffect(() => {
    // Global callback for rewarded ads
    window.onAdRewarded = () => {
      setCoins(prev => prev + 10);
      setShowOopsPopUp(false);
      setLoadingAd(false);
      alert("Successfully added 10 coins!");
    };

    window.onAdStarted = () => {
      setLoadingAd(false);
      if (adTimerRef.current) {
        clearTimeout(adTimerRef.current);
      }
    };

    return () => {
      delete window.onAdRewarded;
      delete window.onAdStarted;
      if (adTimerRef.current) clearTimeout(adTimerRef.current);
    };
  }, []);

  // useEffect(() => {
  //   let count = 0;

  //   const interval = setInterval(() => {
  //     if (window.loadRewardAd) {
  //       window.loadRewardAd();
  //       clearInterval(interval);
  //       return;
  //     }

  //     count++;

  //     if (count >= 5) {
  //       clearInterval(interval);
  //     }
  //   }, 1000);

  //   return () => clearInterval(interval);
  // }, []);

  const triggerAdFlow = () => {
    setLoadingAd(true);
    setAdError('');

    if (window.loadRewardAd) {
      window.loadRewardAd();

      // Set 7 second timeout
      adTimerRef.current = setTimeout(() => {
        setLoadingAd(false);
        setAdError('Ad cannot run, please try again');
      }, 7000);
    } else {
      setLoadingAd(false);
      setAdError('Ad system not ready, please try again');
    }
  };

  const playWithPreroll = (url) => {
    if (window.playPrerollAd) {
      window.playPrerollAd(url);
    } else {
      window.location.href = url;
    }
  };

  const handlePlayClick = (url) => {
    if (coins > 0) {
      setCoins(prev => prev - 10);
      playWithPreroll(url);
    } else {
      setPendingUrl(url);
      setShowOopsPopUp(true);
    }
  };

  const handleClaim = () => {
    triggerAdFlow();
  };

  const watchAdForCoins = () => {
    triggerAdFlow();
  };

  return (
    <>
      {/* OOPS Popup */}
      {showOopsPopUp && (
        <div className="popup-overlay">
          <div className="popup-content oops-popup text-center">
            <div className="oops-header">
              <div className="oops-title-text">OOPS</div>
            </div>
            <div className="oops-text">You don't have enough coins to join this contest.</div>
            <div className="oops-subtext">Just watch an ad & earn 10 coins</div>
            {adError && <div className="text-danger mb-2 fw-bold">{adError}</div>}
            <button className="claim-btn" onClick={handleClaim} disabled={loadingAd}>
              {loadingAd ? "LOADING AD..." : "CLAIM"}
            </button>
            <button className="skip-text" onClick={() => { window.location.href = pendingUrl }} disabled={loadingAd}>Skip</button>
            <span style={{ position: 'absolute', top: '50%', right: '-30px', transform: 'rotate(90deg)', color: '#999', fontSize: '12px' }}>Ad</span>
          </div>
        </div>
      )}

      {
        showPopUp && <div className="popup-overlay" id="popupOverlay" style={{ display: "flex" }}>
          <div className="popup-content">
            <button className="close-popup" onClick={() => { setshowPopUp(false) }} >x</button>
            <div style={{ textAlign: "center" }}>
              {<AdComponent
                client="ca-pub-2248973218739803"
                slot="6919631838"
                format="auto"
                style={{ display: 'block', width: '100%', height: '250px' }}
              />}
            </div>
          </div>
        </div>
      }
      <div className='Main_Bg'>
        <div className='content-section'>
          {/* <Header /> */}
          <div className='p-1 sm:p-3'>

            <AdComponent
              client="ca-pub-2248973218739803"
              slot="9826680987"
              format="auto"
              style={{ display: 'block', width: '100%', height: '280px' }}
            />

            {/* <ins class="adsbygoogle"
              style="display:block"
              data-ad-format="autorelaxed"
              data-ad-client="ca-pub-2248973218739803"
              data-ad-slot="7492702547"></ins>
            <script>
              (adsbygoogle = window.adsbygoogle || []).push({ });
            </script> */}
            {/* Coin Dashboard Section */}
            <div className='coin-dashboard  position-relative'>
              <div className='coin-amount-box'>
                <FaCoins style={{ color: '#fbc02d', fontSize: '18px' }} />
                <span style={{ fontWeight: '800' }} className="h6 mb-0">{coins} Coins</span>
              </div>
              <div className='mt-3 d-flex flex-column align-items-center justify-content-center'>
                {adError && !showOopsPopUp && <div className="text-danger mb-2 fw-bold">{adError}</div>}
                <button
                  className='add-coin-btn'
                  onClick={watchAdForCoins}
                  disabled={loadingAd}
                >
                  <FaVideo /> {loadingAd ? "Loading Ad..." : "Get 10 Free Coins"}
                </button>
              </div>
              <div className='position-absolute end-0 bottom-0 p-2 px-3 h6' style={{ opacity: 0.5 }}>Ad</div>
            </div>

            <AdComponent
              client="ca-pub-2248973218739803"
              slot="4118268003"
              format="auto"
              style={{ display: 'block', width: '100%', height: 'auto' }}
            />

            <div className='sm:px-2'>
              {/* <div className='custom-card mt-4 py-4'>
                <div className='custom-heading h4'>Play online free poki games</div>
                <button
                  className='mt-4 p-2 px-4 custom-button'
                  onClick={() => handlePlayClick("https://www.playpokigames.com")}
                >
                  Click to play
                </button>
              </div> */}
              <div className='custom-card mt-4 py-4'>
                <div className='custom-heading h6 sm:h5 mb-4'>Prefer games which you want to play</div>
                <a href='javascript:void(0)' onClick={() => handlePlayClick("https://www.playpokigames.com")} className='mt-4 custom-button p-2 px-2 cursor-pointer text-decoration-none'
                  // id="cargame"
                >
                  Arcade
                </a>
                <a href='javascript:void(0)' onClick={() => handlePlayClick("https://www.playpokigames.com")} className='mt-4 ms-2 custom-button p-2 px-2 cursor-pointer text-decoration-none'
                >
                  Puzzle
                </a>
                <a
                  href='javascript:void(0)' onClick={() => handlePlayClick("https://www.playpokigames.com")} className='mt-4 ms-2 custom-button p-2 px-2 cursor-pointer text-decoration-none'
                >
                  Casual
                </a>
                <a href='javascript:void(0)' onClick={() => handlePlayClick("https://www.playpokigames.com")} className='mt-4 ms-2 custom-button p-2 px-2 cursor-pointer text-decoration-none'
                >
                  Action
                </a>
              </div>
            </div>

            <AdComponent
              client="ca-pub-2248973218739803"
              slot="5239777987"
              format="auto"
              style={{ display: 'block', width: '100%', height: 'auto' }}
            />

            <div className='pt-4'>
              <HomeGames onPlay={handlePlayClick} />
            </div>

            <AdComponent
              client="ca-pub-2248973218739803"
              slot="2769647456"
              format="auto"
              style={{ display: 'block', width: '100%', height: 'auto' }}
            />

            <div className='px-2 my-4 w-100'>
              <a href='javascript:void(0)' onClick={() => handlePlayClick("https://www.playpokigames.com")} className='custom-button w-100 py-3 cursor-pointer text-decoration-none'
              >
                More Games
              </a>
            </div>

            <AdComponent
              client="ca-pub-2248973218739803"
              slot="7561286625"
              format="auto"
              style={{ display: 'block', width: '100%', height: 'auto' }}
            />
            {/* <AdComponent
              client="ca-pub-2248973218739803"
              slot="1462203285"
              format="autorelaxed"
              style={{ display: 'block' }}
            /> */}
            <AboutSection />

            <AdComponent
              client="ca-pub-2248973218739803"
              slot="2308959944"
              format="auto"
              style={{ display: 'block', width: '100%', height: 'auto' }}
            />
          </div>
          <Footer />
        </div>
      </div>
    </>
  )
}

export default Home